import { select } from '@angular-redux/store';
import { KeyValue } from "@angular/common";
import { ChangeDetectorRef, Directive, ElementRef, EventEmitter, Output, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable, Subject, throwError as observableThrowError } from 'rxjs';
import { catchError, filter, take, takeUntil } from 'rxjs/operators';
import { BaseComponent } from "sharedFeatures/base";
import { ListDropEvent, ListDropTargetDirective } from "sharedFeatures/directives";
import { MoveBtnComponent, NewPlanForm, PLSubmenuDropdownPopupComponent } from 'sharedFeatures/newplan-win';
import { XeroAccountItem } from 'sharedFeatures/newplan-win/models';
import { SaveClosePane } from "sharedFeatures/save-close-pane";
import { ScrollComponent } from "sharedFeatures/scroll";
import { PlanData } from "sharedFeatures/sharedModels";
import { AccountsModel } from "sharedFeatures/sharedModels/xero/accountsModel";
import { DragData } from "sharedFeatures/sharedModels/xero/dragData";
import { XeroMatchedAccount } from "sharedFeatures/sharedModels/xero/xeroMatchedAccount";
import { XeroService } from 'sharedFeatures/sharedServices';
import { SubmenuItem } from 'sharedFeatures/submenu';
import { Utils } from "sharedFeatures/utils";
import { xeroSettingsActions } from 'sharedFeatures/store';
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';

const amBSAccounts = 2;

@Directive()
export class Xi3BalanceSheetBaseComponent extends BaseComponent {

    protected dropdownPopup: PLSubmenuDropdownPopupComponent | undefined;

    isMatchingsLoaded: boolean = false;
    dropPosition: string = '';
    dummyAccount: XeroMatchedAccount = new XeroMatchedAccount();

    protected accountItems: Array<SubmenuItem> = [];
    taxSystem: string = '';
    @ViewChild(NgForm)
    protected form!: NgForm;

    subHeadingsMap: Map<string, Array<string>> = new Map<string, Array<string>>();

    protected saveClosePane: SaveClosePane | undefined;

    @Output() onCOASaved = new EventEmitter<boolean>();

    protected xeroService: XeroService;
    private appComponent!: any;

    protected bodyViewRef: ViewContainerRef;

    public isShowClose: boolean = true;

    private storeUnsubscribe = new Subject<void>();

    @select(['plan', 'planData'])
    readonly planData$!: Observable<PlanData>;
    planData: PlanData = new PlanData();

    @select(['xeroSettings', 'bsAccounts'])
    readonly bsAccounts$!: Observable<AccountsModel>;
    bsAccountsData: AccountsModel = {};
    initialBsAccountsData: AccountsModel = {};

    protected afterSaveCallback: Function | undefined;

    protected chDet: ChangeDetectorRef;

    constructor(
        el: ElementRef,
        r: Renderer2,
        xeroService: XeroService,
        bodyViewRef: ViewContainerRef,
        chDet: ChangeDetectorRef
    ) {
        super(el, r);

        this.xeroService = xeroService;
        this.bodyViewRef = bodyViewRef;
        this.chDet = chDet;

        this.bsAccounts$.pipe(
            takeUntil(this.storeUnsubscribe))
            .subscribe(x => {
                this.bsAccountsData = x;

                if (x) this.initialBsAccountsData = JSON.parse(JSON.stringify(x));

                this.loadAccountItems();
            });
    }

    getForm(): NgForm {
        return this.form;
    }

    ngOnInit() {
        this.planData$.pipe(filter(x => !!x), take(1),
            catchError(reason => {
                console.error('getPlanData error', reason);
                return observableThrowError(reason);
            }))
            .subscribe((planData: PlanData) => {
                this.planData = planData;
            });
    }

    ngAfterViewInit() {
        console.log("ngAfterViewInit")

    }

    getSubheadingClass(subheading: string): string {

        if (subheading == '')
            return 'hiddenCls';
        else if (subheading == 'INVENTORY')
            return 'accountSubheading1';
        else if (subheading == 'Accumulated depreciation/ amortisation')
            return 'accountSubheading1';
        else
            return 'accountSubheading2';

    }

    public isSaveClosePaneHidden(): boolean {

        return !this.saveClosePane || this.saveClosePane.isHidden();
    }

    private updateEmptyHeading(key: string): void {

        const subHeadings = this.subHeadingsMap.get(key);
        let isEmpty: boolean = false;

        const bsAccountsKey = this.bsAccountsData[key];
        if (bsAccountsKey)
            bsAccountsKey.forEach((item) => {
                if (Utils.isEmpty(item['AccountSubHeading']) && item['AccountName'] != 'None') {
                    isEmpty = true;
                    return;
                }
            });

        if (subHeadings) {
            if (isEmpty && !subHeadings.some((vl) => { return Utils.isEmpty(vl); })) {
                subHeadings.push('');
            }
        }
    }

    handleItemClick(tableSubmenuItem: XeroAccountItem, tableItem: XeroMatchedAccount, itemTitle: string, itemSubHeading: string, spliceIndex: number = -1): void {

        let index = tableSubmenuItem.value.indexOf(tableItem);
        if (index > -1) {
            tableSubmenuItem.value.splice(index, 1);
            // search for another items with given subheading
            if (tableItem.AccountSubHeading != '' && !tableSubmenuItem.value.find(x => x.AccountSubHeading == tableItem.AccountSubHeading))
                // add 'None' item with given subheading if not exists
                tableSubmenuItem.value.splice(index, 0, {
                    AccountID: '',
                    AccountCode: '',
                    DisplayCode: '',
                    AccountClass: '',
                    AccountHeading: tableItem.AccountHeading,
                    AccountName: 'None',
                    DisplayName: '',
                    AccountSubHeading: tableItem.AccountSubHeading,
                    AccountType: 0,
                    BankAccountType: 0,
                    TaxType: '',
                    PLValues: [],
                    CFValues: [],
                    MatchType: tableItem.MatchType,
                    matchedXeroLinks: [],
                    CFValueZ: [],
                    PLValueZ: [],
                    _PLValueZ: [],
                    _CFValueZ: [],
                    IsHidden: false,
                });
        }

        if (itemSubHeading)
            tableItem.AccountSubHeading = itemSubHeading;
        else
            tableItem.AccountSubHeading = '';

        tableItem.AccountHeading = itemTitle;

        const bsAccountsKey = this.bsAccountsData[itemTitle];
        if (bsAccountsKey)
            spliceIndex > -1 ? bsAccountsKey.splice(spliceIndex, 0, tableItem) : this.pushIfNotExist(bsAccountsKey, tableItem);

        this.updateEmptyHeading(tableSubmenuItem.key);
        this.updateEmptyHeading(itemTitle);
    }

    pushIfNotExist(arr: XeroMatchedAccount[], item: XeroMatchedAccount) {
        if (arr.indexOf(item) === -1)
            arr.push(item);

        return arr;
    }

    public saveClosePanePlaceEl(): Element | undefined { return undefined; }
    public getPlanGuid(): string { return ''; }

    getScrollTop(): number {

        let el = this.getElDom();

        return el.scrollTop;
    }

    setScrollTop(top: number): void {

        let el = this.getElDom();

        el.scrollTop = top;
    }


    onCancel(): void {

        const scrollPos = this.getScrollTop();
        this.reload(() => { this.setScrollTop(scrollPos); });

        if (this.saveClosePane) {
            this.saveClosePane.close();
            this.saveClosePane = undefined;
        }

    }

    getTaxSystem(): string {
        let result = 'vat';

        let newPlanData = localStorage.getItem('newPlanData');

        if (newPlanData) {
            let jNewPlanData = JSON.parse(newPlanData);
            result = jNewPlanData.aVatText;
        }

        return result;
    }

    public updateTaxSystem(): void {
        this.taxSystem = this.getTaxSystem();
    }

    public reload(callback?: Function): void {

        this.updateTaxSystem();

        if (!this.isMatchingsLoaded) {
            this.loadBSAccounts();
            this.isMatchingsLoaded = true;
        }
    }

    onSave(autosave: boolean, callback?: Function): void {
        this.xeroService.SetAccountsMatch(this.bsAccountsData, amBSAccounts).then((res) => {
            this.xeroService.XeroRefreshCOA(this.getPlanGuid(), undefined, res.AccountsList).then((res) => {

                this.onCOASaved.emit();
                if (callback) callback();
                if (this.afterSaveCallback) this.afterSaveCallback(autosave);

            });

            if (this.saveClosePane) this.saveClosePane.close();
            this.saveClosePane = undefined;
        });
    }

    protected onParentClose(): void {

        if (this.saveClosePane) this.saveClosePane.close();
        this.saveClosePane = undefined;

    }

    toggleDropdownPopup(item: XeroAccountItem, acc: XeroMatchedAccount, btn: MoveBtnComponent): void {
        btn.setActive(!btn.isActive());

        if (btn.isActive()) {

            let ref: ViewContainerRef = this.bodyViewRef;

            let rf = ref.createComponent(PLSubmenuDropdownPopupComponent);

            this.dropdownPopup = rf.instance;

            this.dropdownPopup.initExt(btn.getEl(), this.accountItems, item, acc, this.handleItemClick.bind(this, item, acc));

            // Calculate popup position
            const rect = btn.getEl().getBoundingClientRect();

            this.dropdownPopup.getOnClose().subscribe(() => {

                btn.setActive(false);

                const ind = ref.indexOf(rf.hostView);

                if (ind !== -1)
                    ref.remove(ind);

            });

            let scrollPane = this.getScrollPane();
            if (scrollPane !== undefined)
                this.dropdownPopup.show(rect.left + rect.width / 2 - DomSmallUtils.offset(this.getElDom()).left - this.dropdownPopup.getWidth(), scrollPane.getElDom().scrollTop - scrollPane.getElDom().offsetTop + rect.bottom + 12 + 3);

        }

        else {
            if (this.dropdownPopup)
                this.dropdownPopup.close();

        }

    }

    getPFieldID(key: string): string {
        let result = key;

        if (key === 'Inventory')
            result = 'BSAccountsInventory';

        if (key === 'VAT Liability' || key === 'GST Liability' || key === 'Sales Tax Liability')
            result = 'Tax Liability';

        return result;
    }

    loadAccountItems(): void {
        if (this.accountItems.length > 0)
            this.accountItems = [];

        let i = 0;
        for (let key in this.bsAccountsData) {

            let subHeadings = new Array<string>();
            const bsAccountsKey = this.bsAccountsData[key];

            let isEmpty: boolean = false;
            if (bsAccountsKey)
                bsAccountsKey.forEach((item) => {
                    if (Utils.isEmpty(item['AccountSubHeading'])) {
                        isEmpty = true;
                        return;
                    }
                    if (Utils.isValue(item['AccountSubHeading']) && subHeadings.indexOf(item['AccountSubHeading']) == -1)
                        subHeadings.push(item['AccountSubHeading']);
                });

            i++;
            if (isEmpty) subHeadings.push('');

            const item: SubmenuItem = { id: i, title: key, testId: i + '_testId', active: false, subHeadings: subHeadings };
            this.accountItems.push(item);
            this.subHeadingsMap.set(key, subHeadings);
        }

    }

    itemsBySubHeading(key: string, subHeading: string): Array<XeroMatchedAccount> {

        const accs = new Array<XeroMatchedAccount>();

        const bsAccountsKey = this.bsAccountsData[key];
        if (bsAccountsKey)
            bsAccountsKey.forEach((acc) => {
                if (acc['AccountSubHeading'] === subHeading && acc['AccountName'] != 'None')
                    accs.push(acc);
            });

        return accs;

    }

    isGroupNone(key: string): boolean {

        let isNone = true;

        const bsAccountsKey = this.bsAccountsData[key];
        if (bsAccountsKey)
            bsAccountsKey.forEach((item) => {
                if (!Utils.isEmpty(item['AccountName']) && item['AccountName'] != 'None')
                    isNone = false;
            });

        return isNone && (this.subHeadingsMap.get(key)?.length ?? 0) <= 1;
    }

    loadBSAccounts(failureFn?: Function, callback?: Function): void {

        this.xeroService.GetAccountsMatch(NewPlanForm.amBSAccounts).then((BSAccounts) => {

            if (typeof (BSAccounts.success) == "undefined") return;

            if (BSAccounts.success)
            {
                xeroSettingsActions.setXeroBSAccounts(JSON.parse(BSAccounts.AccountsList));
                if (callback) callback();
            }
            else {
                if (failureFn) failureFn();
            }

        });

    }

    loadImportedBSAccounts(callback?: Function): void {
        this.updateTaxSystem();

        if (this.planData && this.planData.xeroConnected)
        {
            this.xeroService.GetImportedAccountsMatch(this.getPlanGuid(), NewPlanForm.amBSAccounts).then((BSAccounts) => {
                if (BSAccounts && BSAccounts.AccountsList) {
                    xeroSettingsActions.setXeroBSAccounts(JSON.parse(BSAccounts.AccountsList));
                    this.chDet.detectChanges();
                    if (callback) callback();
                }
            });

        }

    }

    sortNull(a: KeyValue<string, Array<XeroMatchedAccount>>, b: KeyValue<string, Array<XeroMatchedAccount>>): number {
        // dummy sorting for keyvalue original order
        return 0;
    }

    public onGoOut(callback?: Function): void {

        if (!this.bsAccountsData) {
            setTimeout(() => this.onGoOut(callback), 100);
            return;
        }

        this.xeroService.SetAccountsMatch(this.bsAccountsData, amBSAccounts).then((res) => {
            xeroSettingsActions.setXeroBSAccounts(JSON.parse(res.AccountsList));
            if (callback) callback();

        });

    }

    onClose() {}
    drgstart(ev: Event): void {}

    protected onGetOff(): void {

        if (this.saveClosePane && !this.isSaveClosePaneHidden()) {

            this.onSave(true, () => {

                if (this.afterSaveCallback) this.afterSaveCallback();

            });

            if (this.saveClosePane) this.saveClosePane.close();
            this.saveClosePane = undefined;

        }

    }

    ngOnDestroy() {
        this.onGetOff();
        this.storeUnsubscribe.next();
        this.storeUnsubscribe.complete();
    }

    handleItemKey(key: string) {
        if (key === "VAT Liability")
        {
            if (this.taxSystem == "gst")
                key = "GST Liability";
            else if (this.taxSystem == "salesTax")
                key = "Sales Tax Liability";
        }

        return key;
    }

    getScrollPane(): ScrollComponent | undefined {
        return undefined;
    }

    bsAccountsDataNotChanged(): boolean {
        for (const item in this.bsAccountsData) {
            const curDataArray = this.bsAccountsData[item];
            const initialDataArray = this.initialBsAccountsData[item];

            for (const initialAccount of initialDataArray) {

                if (!initialAccount.AccountCode) continue;

                let accountIsPresentInCurrentData = curDataArray.find(curAccount => curAccount && initialAccount && (curAccount.AccountCode === initialAccount.AccountCode)
                                                                                                                 && (curAccount.AccountSubHeading === initialAccount.AccountSubHeading));
                if (!accountIsPresentInCurrentData) return false;
                let accountIsOnSameIndex = curDataArray.indexOf(accountIsPresentInCurrentData) === initialDataArray.indexOf(initialAccount);

                if (!accountIsOnSameIndex)
                    return false;
            }
        }

        return true;
    }

    getDropPosition(ev: MouseEvent, dragData: any, targetEl: Element): string {

        if (!targetEl.getAttributeNames().includes('draggabled')) return '';

        if (ev.pageY < (targetEl.getBoundingClientRect().top + window.scrollY) + targetEl.clientHeight / 3) {
            this.dropPosition = 'before';
            return 'before';
        }

        else if (ev.pageY > (targetEl.getBoundingClientRect().top + window.scrollY) + targetEl.clientHeight * (2/3)) {
            this.dropPosition = 'after';
            return 'after';
        }

        this.dropPosition = 'append';
        return 'append';
    }

    isDropAllowed(dragData: DragData, targetEl: Element, position: string): boolean {
        return true;
    }

    onDragOver(ev: MouseEvent, directive: ListDropTargetDirective, dragData: DragData): void {
        if (dragData.isComponent) directive.onDragOverDefault(ev);
    }

    onDragEnter(ev: Event, directive: ListDropTargetDirective, dragData: DragData): void {
        if (dragData.isComponent) directive.onDragEnterDefault(ev);
    }

    onDragLeave(ev: Event, directive: ListDropTargetDirective, dragData: DragData): void {
        if (dragData.isComponent) directive.onDragLeaveDefault(ev);
    }

    onItemDragOver(ev: DragEvent, item: XeroMatchedAccount, directive: ListDropTargetDirective, dragData: DragData): void {
        if (dragData.isComponent) directive.onItemDragOverDefault(ev, item, directive, dragData);
    }

    onItemDragEnter(ev: DragEvent, item: XeroMatchedAccount, directive: ListDropTargetDirective, dragData: DragData): void {
        if (dragData.isComponent) directive.onItemDragEnterDefault(ev, item, directive, dragData);
    }

    onItemDragLeave(ev: DragEvent, item: XeroMatchedAccount, directive: ListDropTargetDirective, dragData: DragData): void {
        if (dragData.isComponent) directive.onItemDragLeaveDefault(ev, item, directive, dragData);
    }

    onDrop(ev: Event, directive: ListDropTargetDirective, dragData: DragData): void {
        //if (dragData.isComponent) directive.onDropDefault(ev);
    }

    onDropping(item: XeroAccountItem, acc: XeroMatchedAccount, ev: ListDropEvent): void {

        let draggedAccountsArray = this.bsAccountsData[ev.dragData.node.AccountHeading];
        let dropIndex = 0;

        if (acc.AccountCode) {
            let draggedAccount = draggedAccountsArray.find(x => x.AccountCode === ev.dragData.node.AccountCode);
            if (!draggedAccount) return;
            let draggedAccountIndex = draggedAccountsArray.indexOf(draggedAccount!);
            let dropAccountArray = this.bsAccountsData[acc.AccountHeading];
            if (!dropAccountArray) return;
            let accountNearDrop = dropAccountArray.find(x => x.AccountCode === acc.AccountCode);
            if (!accountNearDrop) return;
            dropIndex = dropAccountArray.indexOf(accountNearDrop!);

            if ((draggedAccount!.AccountCode === accountNearDrop!.AccountCode && dropIndex === draggedAccountIndex) ||
                ((draggedAccountIndex === (dropIndex - 1) && this.dropPosition === 'before' && acc.AccountSubHeading === draggedAccount!.AccountSubHeading && acc.AccountHeading === draggedAccount!.AccountHeading)) ||
                ((draggedAccountIndex === (dropIndex + 1) && this.dropPosition !== 'before' && acc.AccountSubHeading === draggedAccount!.AccountSubHeading && acc.AccountHeading === draggedAccount!.AccountHeading)))
            {
                return;
            }

            if (draggedAccountIndex === (dropIndex + 1) && (acc.AccountSubHeading !== draggedAccount!.AccountSubHeading) ||
                ((draggedAccountIndex > (dropIndex - 1)) && (!ev.position || this.dropPosition !== 'before') && (acc.AccountHeading === draggedAccount!.AccountHeading)) ||
                (acc.AccountHeading !== draggedAccount!.AccountHeading) && (this.dropPosition !== 'before'))
            {
                ++dropIndex;
            }

            if ((draggedAccountIndex < (dropIndex + 1)) && this.dropPosition === 'before' && (acc.AccountHeading === draggedAccount!.AccountHeading))
            {
                --dropIndex;
            }

            if (draggedAccountIndex > -1) {
                ev.dragData.node.AccountClass = dropAccountArray!.find(x => x.AccountClass)?.AccountClass;
                ev.dragData.node.AccountHeading = dropAccountArray!.find(x => x.AccountHeading)?.AccountHeading;
            }
        } else {
            acc.AccountHeading = item.key;
            acc.AccountSubHeading = ev.targetItem?.parentNode?.previousSibling?.previousSibling?.previousSibling?.textContent?.trim() ?? '';
        }

        let itemForHandle = { key: ev.dragData.node.AccountHeading, value: draggedAccountsArray };
        this.handleItemClick(itemForHandle, ev.dragData.node, acc.AccountHeading, acc.AccountSubHeading, dropIndex);
    }

    getDragData(item: XeroMatchedAccount): DragData {
        return { isComponent: true, groupId: item.AccountSubHeading, node: item };
    }

    getTxt(dragData: { node: XeroMatchedAccount }): string {
        return dragData.node.AccountName;
    }

    isDragAllowed(): boolean {
        return true;
    }
}
